var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrows3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 129.4 26.9",
    style: {
      enableBackground: "new 0 0 129.4 26.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000176031908990132993710000014706947565200365751_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 78.2713,
    y1: 13.4276,
    x2: 129.3605,
    y2: 13.4276
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#77254B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8E2542"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.4,26.9c0,0,6.3,0,13.1-4.7s18.3-14,23.8-14.6c5.5-0.5,11.1,7.1,11.1,7.1S123.1,4.9,118.3,0v1.2 c0,0-2.5-0.3-4.4,0c-1.8,0.3-24.4,14.3-32.5,14.1l1.1,7.6l-2.8-7.2l-1.4,0.6L81.4,26.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085244566935922574710000005290076184791084983_",
    gradientUnits: "userSpaceOnUse",
    x1: -1288.5895,
    y1: 13.4276,
    x2: -1237.5002,
    y2: 13.4276,
    gradientTransform: "matrix(-1 0 0 1 -1237.5002 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#77254B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8E2542"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085244566935922574710000005290076184791084983_)"
    },
    d: "M48,26.9c0,0-6.3,0-13.1-4.7 c-6.8-4.7-18.3-14-23.8-14.6C5.6,7,0,14.7,0,14.7S6.2,4.9,11.1,0v1.2c0,0,2.5-0.3,4.4,0C17.3,1.6,39.9,15.5,48,15.3l-1.1,7.6 l2.8-7.2l1.4,0.6L48,26.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrows3);
export default __webpack_public_path__ + "static/media/Brows3.e64c743dcc572167c5d1bdc84af0e304.svg";
export { ForwardRef as ReactComponent };